export class ShortcutTools {
  private static readonly displayNames: Map<string, string> = new Map<string, string>([
    ['Insert', 'Ins'],
    ['Delete', 'Del'],
    ['Escape', 'Esc'],
  ]);

  public static toDisplayName(key: string): string {
    const displayName = this.displayNames.get(key);
    if (!!displayName) {
      return displayName;
    }
    return key;
  }
}
